import { API_BASE, axiosApi } from "../config"
import { GeneralReturnInterface } from "../types"

export interface InvoiceInterface {
    id: number
    billingInstitution: string
    billingContactName: string
    billingEmail: string
    billingAddressLine1: string
    billingAddressLine2?: string
    billingCity: string
    billingState: string
    billingCountry: string
    billingZipcode: string
    paymentMethod: string
    status: 'paid' | 'due' | 'canceled'
    invoiceDetails: any
    subTotal: number
    totalAmount: number
    discount: number
    payment?: number
    notes?: string
    ts: string
    billingDate?: string
    dueDate?: string
    orderIds?: number[]
    orderBillingTypes?: Record<string, string>
    plabAddress?: 'briden' | 'brentwood'
}

export interface GetInvoicesReturnInterface extends GeneralReturnInterface {
    invoices: InvoiceInterface[]
}

export const getInvoices = async (): Promise<GetInvoicesReturnInterface> => {
    return (await axiosApi.post(`${API_BASE}/getInvoices`, {})).data
}

export const createInvoice = async (body: {
    orderIds: number[]
    invoiceDate: string
    dueDate: string
    billingContact: string
    billingEmail: string
    billingAddress: string
    institution: string
    discount?: number
    notes?: string
}): Promise<GeneralReturnInterface> => {
    return (await axiosApi.post(`${API_BASE}/createInvoice`, body)).data
}

export const updateInvoice = async (body: {
    invoiceId: number
    billingInstitution?: string
    billingContactName?: string
    billingEmail?: string
    billingAddress?: string
    paymentMethod?: string
    status?: 'paid' | 'due' | 'canceled'
    billingDate?: string
    dueDate?: string
    plabAddress?: 'briden' | 'brentwood'
    discount?: number
    totalAmount?: number
    payment?: number
    notes?: string
}): Promise<GeneralReturnInterface> => {
    return (await axiosApi.post(`${API_BASE}/updateInvoice`, body)).data
}

export const updateInvoiceOrders = async (body: {
    invoiceId: number
}): Promise<GeneralReturnInterface> => {
    return (await axiosApi.post(`${API_BASE}/updateInvoiceOrders`, body)).data
}

export const cancelInvoice = async (body: {
    invoiceId: number
}): Promise<GeneralReturnInterface> => {
    return (await axiosApi.post(`${API_BASE}/cancelInvoice`, body)).data
}
